import React from "react";
import { Icon } from "@iconify/react";

const SocialLoginButtons = ({
  onGoogleClick,
  onAmazonClick,
  onLinkedInClick,
  showGoogleFull = true
}) => {
  return (
    <div className="social-login">
      {showGoogleFull && (
        <button
          className="social-login__google-btn"
          onClick={onGoogleClick}
          type="button"
        >
          <Icon icon="logos:google-icon" width="20" height="20" />
          <span>Google</span>
        </button>
      )}

      <div className="social-login__icons">
        {!showGoogleFull && (
          <button
            className="social-login__icon-btn"
            onClick={onGoogleClick}
            type="button"
            aria-label="Sign in with Google"
          >
            <Icon icon="logos:google-icon" width="24" height="24" />
          </button>
        )}
        <button
          className="social-login__icon-btn"
          onClick={onLinkedInClick}
          type="button"
          aria-label="Sign in with LinkedIn"
        >
          <Icon icon="logos:linkedin-icon" width="24" height="24" />
        </button>
        <button
          className="social-login__icon-btn"
          onClick={onAmazonClick}
          type="button"
          aria-label="Sign in with Amazon"
        >
          <Icon icon="fa6-brands:amazon" width="24" height="24" />
        </button>
      </div>
    </div>
  );
};

export default SocialLoginButtons;
